module.exports = __webpack_public_path__ + "static/media/details-3.7accee53.jpeg";